

function blockUIConfig(blockUIConfig: any): void {
    blockUIConfig.autoBlock = false;
    blockUIConfig.autoInjectBodyBlock = false;
    blockUIConfig.delay = 50;
    blockUIConfig.message = 'Processing...';
    blockUIConfig.template = require('./blockUI.template.html');
}

blockUIConfig.$inject = ['blockUIConfig'];

export { blockUIConfig };
